import { CaseLinkType, ReportStatus } from 'src/graphql';
import { USER_ROLE } from 'src/types';
import { analytics } from '../analytics';
import { CASE_LINKING_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

export interface TrackCaseLinkDetailsViewedProps {
  organisation_id: number;
  source_case_id: string | null;
  target_case_id: string | null;
  current_case_id: string;
  user_role: USER_ROLE;
  link_type: CaseLinkType | null;
  has_note: boolean | null;
  case_status_source: ReportStatus | null;
  case_status_target: ReportStatus | null;
  is_link_masked: boolean;
}

export const trackCaseLinkDetailsViewedEvent = (
  properties: TrackCaseLinkDetailsViewedProps,
) => {
  return analytics.track(
    CASE_LINKING_EVENT_IDS.LINK_DETAILS_VIEWED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseLinkNavigationClickedEvent = (
  properties: Omit<TrackCaseLinkDetailsViewedProps, 'is_link_masked'>,
) => {
  return analytics.track(
    CASE_LINKING_EVENT_IDS.LINK_NAVIGATION_CLICKED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};
